import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss', '../../../styles/page.preset.style.scss'],
  standalone: false,
})
export class HeaderComponent {
  @Input() TITLE: string;
  @Input() BACKBUTTON: boolean = true;
  @Input() TOHIDE: boolean = false;

  constructor() {}

  get shouldShowBackButton(): boolean {
    return this.BACKBUTTON;
  }
}
